import React, { Component } from "react";
import store from "../store";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import Grid from "@material-ui/core/Grid";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import FormControl from "@material-ui/core/FormControl";

import BackIcon from "@material-ui/icons/ChevronLeft";

import Modal from "react-responsive-modal";
import firebase from "firebase/app";
import "firebase/firestore";
import _ from "lodash";

import ButtonBase from "@material-ui/core/ButtonBase";
import * as STATIC from "../config/static";

import moment from "moment";
import {
  VictoryBar,
  VictoryLine,
  VictoryChart,
  VictoryTheme,
  VictoryLabel,
  VictoryAxis,
  VictoryScatter,
  VictoryLegend,
} from "victory";
import Advance from "./Advance";
import InnerPage from "./InnerPage";
import CircularProgress from "@material-ui/core/CircularProgress";
import TopBar from "../components/TopBar";
const days = [0, 1, 2, 3, 4, 5];
function getParameterByName(name) {
  if (name !== "" && name !== null && name !== undefined) {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
          results = regex.exec(window.location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  } else {
      var arr = window.location.href.split("/");
      return arr[arr.length - 1];
  }
}


let _this;
const DWIDTH = 980;

class ChartView extends Component {
  constructor() {
    super();
    _this = this;
    let type = "advance";
    let showAdvanceResult = false;
    if(type=="advance"){
      showAdvanceResult = true;
    }
    let advanceDays = parseInt(getParameterByName("days"))||10;
    if(!advanceDays||advanceDays==0)
    {
      advanceDays = 10;
    }
    if(advanceDays>30)
    {
      advanceDays = 30;
    }
    this.state = {
      wWidth: 0,
      wHeight: 0,
      message: "",
      loading: true,
      showResult: false,
      showResultDetail: false,
      showAdvanceResult:showAdvanceResult,
      curWeek: -1,
      curDay: -1,
      course: null,
      result: {},
      showChart: false,
      isGuest: false,
      g_practice: false,
      curLegend: "All",
      saving: false,
      saving_error: false,
      isMore: 0,
      advanceDays:advanceDays,
      ACCOUNT:false,
      account_id:getParameterByName("id")
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = (name) => (event) => {
    event.preventDefault();
    this.setState({
      [name]: event.target.value,
    });
  };

  handleDelete = (name, value) => {
    let change = _this.state[name];
    //console.log(name,value,change);
    change = _.without(change, value);
    //  console.log(change);
    this.setState({
      [name]: change,
    });
  };
  
  
 
  async componentDidMount() {
    let LANG = "vi";
    this.props.i18n.changeLanguage(LANG);
      localStorage.setItem('LANG',LANG);
      store.dispatch({ type: 'LANG', LANG: LANG });
    console.log('Business',"test");
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if(this.state.account_id)
    {
      this.loadAccount();
    }
    
    // let LASTDAY = localStorage.getItem('LASTDAY');
    // if (LASTDAY) {
    //   LASTDAY = JSON.parse(LASTDAY);
    //   store.dispatch({ type: 'LASTDAY', LASTDAY });
    // }
    // else {
    //   LASTDAY = { week: 0, day: 1 };
    //   store.dispatch({ type: 'LASTDAY', LASTDAY });
    //   localStorage.setItem('LASTDAY', JSON.stringify(LASTDAY));
    // }
  }

 async loadAccount() {
    let doc = await firebase
    .firestore()
    .collection("data_teachers")
    .doc("data_teachers" + "-" + this.state.account_id)
    .get();
    if(doc.exists)
    {
      let ACCOUNT = doc.data();
      ACCOUNT.ten = ACCOUNT.hoten;
      await _this.setState({ACCOUNT});
      //let ACCOUNT = _this.state.ACCOUNT;
      //console.log(ACCOUNT);
      // let data = await firebase.firestore().collection('courses').where('course_id','==',ACCOUNT.idkhoahoc).get();
      // if (data.size>0) {
      //   let item = {};
      //   data.forEach((d)=>{
      //     item = d.data();
      //     item.id = d.id;
      //   })
      //   await _this.setState({ course: item });
      // }
       this.loadChartResult();
    }

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }

  getResultText(curStar) {
    let resultText = "Good";
    if (curStar == 3) {
      resultText = "Perfect";
    } else if (curStar == 2.5) {
      resultText = "Excellence";
    } else if (curStar > 1 && curStar <= 2) {
      resultText = "Very Good";
    }
    return resultText;
  }

  submitForm(e) {
    e.preventDefault();
    _this.setState({ submitted: true });
  }

  onCloseModal(e) {
    _this.setState({ showResult: false, curDay: -1 });
  }
  
  getQuestionEQ(question, width) {
    let rel = "";
    if (question.type != "image" && question.type != "soroban") {
      for (let num of question.numbers) {
        if (question.type != "multiple" && question.type != "divide") {
          if (rel == "") {
            rel = num;
            continue;
          } else {
            rel += (num >= 0 ? " + " : " - ") + Math.abs(num);
          }
        } else {
          if (rel == "") {
            rel += num;
          } else {
            rel += "" + num;
          }
        }
      }
    } else if (question.type == "soroban") {
      rel = "Soroban";
    } else {
      rel = (
        <div style={{ display: "inline-block" }}>
          {question.images.map((i, index) => {
            i = i.replace("_", "-");
            i = i.replace("finger/f", "finger/");
            return (
              <img
                key={"image" + index}
                src={i}
                style={{
                  width: STATIC.calSize(30, STATIC.DWIDTH, width),
                  height: "auto",
                }}
              />
            );
          })}
        </div>
      );
    }
    return rel;
  }
  async loadChartResult() {
    let { course,ACCOUNT,showAdvanceResult,advanceDays } = _this.state;
    console.log(course);
    if (!course) course = { id: "0", week: 12 };
   // let ACCOUNT = store.getState().ACCOUNT;
    //await _this.setState({loading:true});
    
   
    let RESULTS = [];
    let chartData = [];
    
    
    //console.log(chartData);
    let doc2 = await firebase
      .firestore()
      .collection("data_teachers")
      .doc("data_teachers" + "-" + ACCOUNT.id)
      .collection("results")
      .doc("_ADVANCE_")
      .get();
    let RESULTS2 = [];
    let chartData2 = [];
    let dateList = [];
    for (let i = advanceDays-1; i >= 0; i--) {
      let item = moment()
        .subtract(i, "days")
        .format("YYYY-MM-DD");
      dateList.push(item);
    }
    let startDate =
      moment()
        .subtract(advanceDays-1, "days")
        .format("YYYY-MM-DD") + " 00:00:00";

    let legends = [];
    let keyOptions = ["All"];
    let rArr = [];
    if(showAdvanceResult)
    {
      let aData2 = await firebase
      .firestore()
      .collection("data_teachers")
      .doc("data_teachers" + "-" + ACCOUNT.id)
      .collection("_ADVANCE_")
      .where("created", ">=", moment(startDate).valueOf())
      .orderBy("created", "desc")
      .get();
    
    if (aData2.size > 0) {
      aData2.forEach((doc) => {
        let r = doc.data();
        rArr.push(r);
      });
    }
    console.log(rArr);
    if (doc2.exists) {
      rArr = rArr.concat(doc2.data().results);
    }
    if (rArr.length > 0) {
      rArr.forEach((item) => {
        item.date = moment(item.created).format("YYYY-MM-DD");
        if (item.date >= dateList[0] && item.group != undefined) {
          if (item.group && item.group != "") {
            RESULTS2.push(item);
          }
        }
      });
      RESULTS2 = _.sortBy(RESULTS2, ["date"], ["desc"]);
      RESULTS2 = _.groupBy(RESULTS2, "group");

      for (let key of Object.keys(RESULTS2)) {
        let agroup = STATIC.AGROUP[key];
        //console.log("key1",key);
        if (!agroup) {
          console.log("key2", key);
          return;
        }
        legends.push({
          name: key,
          symbol: { fill: agroup.color, type: agroup.symbol },
        });
        keyOptions.push(key);
        let tArr = [];
        for (let rel of dateList) {
          //console.log(rel);
          let arr = RESULTS2[key].filter((i) => i.date == rel);
          let percent = 0;
          if (arr.length > 0) {
            percent = _.sumBy(arr, "percent");
            percent = percent ? Math.round(percent / arr.length) : 0;
          }

          //  console.log(arr);

          let item = {
            name: moment(rel, "YYYY-MM-DD")
              .format("D-M")
              .toString(),
            y: percent,
            ...STATIC.AGROUP[key],
            key,
            date: rel,
          };
          tArr.push(item);
        }

        chartData2.push(tArr);
      }
    }
    }
    
    _this.setState({
      showChart: true,
      chartData,
      RESULTS,
      RESULTS2,
      legends,
      keyOptions,
      curLegend: "All",
      chartData2,
      //showAdvanceResult: false,
      loading: false
    });
  }
  async showChartDetailResult(index) {
    let { chartData, RESULTS } = _this.state;
    let chartDetailData = [];
    for (let i = 0; i < 6; i++) {
      let filtered = RESULTS.filter((t) => t.week == index && t.day == i);
      let percent = _.sumBy(filtered, "percent");
      //console.log(filtered,percent);
      percent = percent ? Math.round(percent / filtered.length) : 0;
      let item = { name: (i + 1).toString(), percent, length: filtered.length };
      chartDetailData.push(item);
    }
    _this.setState({
      showChartDetail: true,
      chartDetailData,
      chartWeekIndex: index,
    });
  }
  clickChart(index) {
    //return;
    if (_this.state.showChartDetail) {
      let { chartWeekIndex, RESULTS } = _this.state;
      let filtered = RESULTS.filter(
        (t) => t.week == chartWeekIndex && t.day == index
      );
      if (filtered && filtered.length > 0)
        _this.setState({
          showResultDetail: true,
          fResults: filtered,
          result: filtered[0],
          rIndex: 0,
        });
      return;
    }
    _this.showChartDetailResult(index);
  }
  clickChart2(key, date) {
    return;
    let { RESULTS2 } = _this.state;
    let filtered = RESULTS2[key].filter((i) => i.date == date);
    if (filtered && filtered.length > 0)
      _this.setState({
        showResultDetail: true,
        fResults: filtered,
        result: filtered[0],
        rIndex: 0,
      });
  }
  changeResult(index) {
    let { fResults } = _this.state;
    if (index <= fResults.length - 1 && index >= 0) {
      _this.setState({ result: fResults[index], rIndex: index });
    }
  }
  render() {
    const { classes, t } = this.props;
    const {
      wWidth,
      wHeight,
      loading,
      curWeek,
      curDay,
      course,
      legends,
      saving_error,
      ACCOUNT,showAdvanceResult
    } = this.state;
    let width = wWidth;
    
    let cRate = 800 / 450;
    let sRate = 800 / 600;
    if(!showAdvanceResult)
    {
       cRate = 800 / 500;
    }
    let height = width/sRate;
    // if(height>wHeight) 
    // {height = wHeight;
    //   width  = wHeight * sRate;
    // }

    // if ((curWeek > -1 && curDay > -1) || showAdvance) {
    //   sRate = 980 / 640;
    // }
    let chart_height = width/cRate;

    console.log(chart_height,)
    
    
    
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let fSmallest = width * 0.01;
   
    let weeks = [];
    if (course) {
      for (let i = 0; i < course.week; i++) {
        weeks.push(i);
      }
    }
   
    
    let chartData2 = this.state.chartData2;
    if (this.state.curLegend != "" && this.state.curLegend != "All") {
      let index = this.state.keyOptions.indexOf(this.state.curLegend);
      console.log(index);
      if (index > -1 && chartData2.length > index - 1) {
        chartData2 = [chartData2[index - 1]];
      }
    }

    //let LASTDAY = store.getState().LASTDAY;

    
    if (loading) {
      return (
        <div
          className={classes.root}
          style={{background:"none",backgroundColor:"white"}}
          
        >
          <div className={classes.middle}>
            <div
              className={classes.square}
              style={{ maxWidth: width }}
              elevation={4}
            >
              <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <CircularProgress style={{ color: "rgb(5, 63, 34)" }} />
                  </div>
                </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className={classes.root}
        style={{ background: "none",color:"black" }}
      >
        <div className={classes.middle}>
          
              <div style={{width: width, height: height}}>
                <div style={{ display: "flex" }}>
                  {this.state.showChartDetail &&
                  !this.state.showAdvanceResult ? (
                    <ButtonBase
                      focusRipple
                      onClick={() => this.setState({ showChartDetail: false })}
                      style={{
                        marginTop: STATIC.calSize(10, STATIC.DWIDTH, width),
                        width: STATIC.calSize(30, STATIC.DWIDTH, width),
                        height: STATIC.calSize(30, STATIC.DWIDTH, width),
                        borderRadius: STATIC.calSize(15, STATIC.DWIDTH, width),
                        backgroundColor: "rgb(0, 104, 56)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <BackIcon style={{ color: "white", fontSize: fTitle }} />
                    </ButtonBase>
                  ) : (
                    false
                  )}
                  {/* {<div
                    style={{
                      textAlign: "center",
                      flexGrow: 1,
                      fontSize: fTitle,
                      marginTop: STATIC.calSize(10, STATIC.DWIDTH, width),
                    }}
                  >
                    {this.state.showChartDetail && !this.state.showAdvanceResult
                      ? t("common.results_for_week") +
                        (this.state.chartWeekIndex + 1)
                      : t("common.results")}
                  </div>} */}
                  <div
                  style={{
                    flexGrow: 1,
                    textAlign: "center",
                    fontSize: fTitle,
                    marginTop: STATIC.calSize(10, STATIC.DWIDTH, width),
                  }}
                >
                  {this.state.showAdvanceResult
                    ? t("common.aresults_for", { name: ACCOUNT.ten })
                    : t("common.tresults_for", { name: ACCOUNT.ten })}
                </div>
                </div>
                
                {this.state.showAdvanceResult ? (
                  <div>
                    <Grid
                      container
                      direction="row"
                      style={{
                        
                        
                      }}
                    >
                      <Grid item>
                        <FormControl style={{ width: width * 0.2 }}>
                          <Select
                            value={this.state.curLegend}
                            onChange={(e) =>
                              this.setState({ curLegend: e.target.value })
                            }
                            style={{
                              backgroundColor: "#fdce07",
                              border: "none",
                              color: "#053f22",
                              padding: STATIC.calSize(5, STATIC.DWIDTH, width),
                              textAlign: "left",
                              fontSize: fNormal,
                            }}
                          >
                            {this.state.keyOptions.map((t, index) => {
                              return (
                                <MenuItem
                                  style={{ fontSize: fNormal }}
                                  key={"province" + index}
                                  value={t}
                                >
                                  {t}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <div
                      style={{
                        height: chart_height,
                        width: wWidth,
                        
                      }}
                    >
                      <VictoryChart
                        height={chart_height}
                        width={wWidth}
                        domainPadding={STATIC.calSize(5,STATIC.DWIDTH, width)}
                        padding={{ top: STATIC.calSize(50, STATIC.DWIDTH, width), bottom: STATIC.calSize(50, STATIC.DWIDTH, width),left:STATIC.calSize(30, STATIC.DWIDTH, width),right:STATIC.calSize(30, STATIC.DWIDTH, width) }}
                      >
                        {chartData2.map((cData, index) => {
                          return [
                            <VictoryScatter
                              key={"sc" + index}
                              style={{
                                data: { fill: ({ datum }) => datum.color },
                                
                              }}
                              size={STATIC.calSize(4, STATIC.DWIDTH, width)}
                              x="name"
                              data={chartData2[index]}
                              events={[
                                {
                                  target: "data",
                                  eventHandlers: {
                                    onClick: () => {
                                      return [
                                        {
                                          target: "data",
                                          mutation: (props) => {
                                            let data = props.data[props.index];
                                            _this.clickChart2(
                                              data.key,
                                              data.date
                                            );
                                          },
                                        },
                                      ];
                                    },
                                  },
                                },
                              ]}
                            />,
                            <VictoryLine
                              key={"VL" + index}
                              interpolation="cardinal"
                              data={chartData2[index]}
                              x="name"
                              labels={({ datum }) => datum.y + "%"}
                              domain={{ y: [0, 100] }}
                              style={{
                                labels: { fill: ({ datum }) => datum.color,fontSize: fSmall },
                                data: {
                                  stroke: cData[0].color,
                                  strokeWidth: STATIC.calSize(
                                    1,
                                    STATIC.DWIDTH,
                                    width
                                  ),
                                },
                              }}
                              labelComponent={
                                <VictoryLabel
                                  dy={
                                    STATIC.calSize(10, STATIC.DWIDTH, width) *
                                    -1
                                  }
                                />
                              }
                              events={[
                                {
                                  target: "data",
                                  eventHandlers: {
                                    onPress: () => {
                                      return [
                                        {
                                          target: "labels",
                                          mutation: (props) => {
                                            console.log(props);
                                            _this.clickChart2(props.index);
                                            return null;
                                          },
                                        },
                                      ];
                                    },
                                  },
                                },
                              ]}
                            />,
                          ];
                        })}
                        <VictoryLegend
                          title=""
                          centerTitle
                          orientation="horizontal"
                          itemsPerRow={6}
                          gutter={STATIC.calSize(10, STATIC.DWIDTH, width)}
                          style={{
                            border: { stroke: "black" },
                            title: { fontSize: 1 },
                            labels: { fontSize: fSmall },
                          }}
                          data={legends.filter(
                            (l) =>
                              this.state.curLegend == "" ||
                              this.state.curLegend == "All" ||
                              this.state.curLegend == l.name
                          )}
                          x={STATIC.calSize(10, STATIC.DWIDTH, width)} y={STATIC.calSize(10, STATIC.DWIDTH, width)}
                        />
                        <VictoryAxis
                          label={
                            this.state.showAdvanceResult
                              ? "Date"
                              : !this.state.showChartDetail
                              ? t("common.week")
                              : t("common.day")
                          }
                          style={{
                            axis: { stroke: "#756f6a" },
                            axisLabel: {
                              fontSize: fSmall,
                              padding: STATIC.calSize(30, STATIC.DWIDTH, width),
                            },

                            ticks: { stroke: "grey", size: 5 },
                            tickLabels: {
                              fontSize: fSmaller,
                              padding: STATIC.calSize(5, STATIC.DWIDTH, width),
                            },
                          }}
                        />
                        <VictoryAxis
                          dependentAxis
                          tickValues={[0, 20, 40, 60, 80, 100]}
                          style={{
                         
                            tickLabels: {
                              fontSize: fSmall,
                              padding:STATIC.calSize(5, STATIC.DWIDTH, width)
                            },
                          }}
                        />
                      </VictoryChart>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      height: chart_height,
                      width: wWidth,
                      
                    }}
                  >
                    <VictoryChart
                      height={chart_height}
                      width={wWidth}
                      domainPadding={{x:STATIC.calSize(15, STATIC.DWIDTH, width),y:STATIC.calSize(0, STATIC.DWIDTH, width)}}
                      padding={{ top: STATIC.calSize(30, STATIC.DWIDTH, width), bottom: STATIC.calSize(50, STATIC.DWIDTH, width),left:STATIC.calSize(30, STATIC.DWIDTH, width),right:STATIC.calSize(30, STATIC.DWIDTH, width) }}
                    >
                      <VictoryBar
                      
                      barWidth = { STATIC.calSize(30, STATIC.DWIDTH, width)}
                        data={
                          this.state.showAdvanceResult
                            ? this.state.chartData2
                            : !this.state.showChartDetail
                            ? this.state.chartData
                            : this.state.chartDetailData
                        }
                        x="name"
                        y="percent"
                        labels={({ datum }) =>
                          datum.percent != 0 ? datum.percent + "%" : ""
                        }
                       
                        style={{
                          labels: {
                            fill: !this.state.showChartDetail
                              ? "white"
                              : "#053f22",
                              fontSize:fSmall
                          },
                          data: {
                            fill: !this.state.showChartDetail
                              ? "#053f22"
                              : "#fdce07",
                            
                          },
                        }}
                        labelComponent={
                          <VictoryLabel
                            dy={STATIC.calSize(20, STATIC.DWIDTH, width)}
                          />
                        }
                        events={[
                          {
                            target: "data",
                            eventHandlers: {
                              onClick: () => {
                                return [
                                  {
                                    target: "labels",
                                    mutation: (props) => {
                                      _this.clickChart(props.index);
                                      return null;
                                    },
                                  },
                                ];
                              },
                            },
                          },
                        ]}
                      />
                      <VictoryAxis
                        label={
                          this.state.showAdvanceResult
                            ? "Date"
                            : !this.state.showChartDetail
                            ? t("common.week")
                            : t("common.day")
                        }
                        style={{
                          axis: { stroke: "#756f6a" },
                          axisLabel: {
                            fontSize: fSmall,
                            padding:STATIC.calSize(30, STATIC.DWIDTH, width)
                          },

                          ticks: { stroke: "grey", size: 5 },
                          tickLabels: {
                            fontSize: fSmall,
                            padding:STATIC.calSize(5, STATIC.DWIDTH, width)
                          },
                        }}
                      />
                      <VictoryAxis
                        dependentAxis
                        tickValues={[0, 20, 40, 60, 80, 100]}
                        style={{
                         
                          tickLabels: {
                            fontSize: fSmall,
                            padding:STATIC.calSize(5, STATIC.DWIDTH, width)
                          },
                        }}
                      />
                    </VictoryChart>
                  </div>
                )}
                
                {/* {<Button
                  style={{
                    color: "#053f22",
                    borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width),
                    padding:
                      STATIC.calSize(8, STATIC.DWIDTH, width) +
                      "px " +
                      STATIC.calSize(24, STATIC.DWIDTH, width) +
                      "px",
                    marginLeft: "auto",
                    minWidth: 0,
                    backgroundColor: "#fdce07",
                    fontSize: fNormal,
                  }}
                  color="primary"
                  size="medium"
                  variant="contained"
                  onClick={() =>
                    this.setState({
                      showAdvanceResult: !this.state.showAdvanceResult,
                    })
                  }
                >
                  {this.state.showAdvanceResult
                    ? t("practice.practice")
                    : t("common.advance")}
                </Button>} */}
              </div>
            
          
        </div>
      </div>
    );
  }
}

ChartView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(STATIC.styles)(STATIC.translate("common")(ChartView));
